import styled from 'styled-components';

import { mediaQueryLaptopMin } from '@/styleUtils';

const PageInnerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;

  @media all and ${mediaQueryLaptopMin} {
    width: 100%;
    flex-direction: row;
  }
`;

export default PageInnerWrapper;
